import clsx from 'clsx';
import { ButtonHTMLAttributes } from 'react';
import { Subtitle } from '../subtitle';

type ButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'className'
> & {
  size: 'lg' | 'md' | 'sm' | 'xs';
  secondary?: boolean;
};

function LargeButton({ secondary, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(
        'min-w-[280px] h-[60px] rounded-[10px] uppercase disabled:bg-gray-soft disabled:shadow-none disabled:border-none text-body shadow-[1px_2px_0_0_#7DA46C]',
        secondary
          ? 'bg-white border border-body shadow-[1px_2px_0_0_#595959] hover:shadow-none focus:border-dark focus:shadow-none'
          : 'bg-green hover:bg-green-hover hover:shadow-none focus:bg-green-focus focus:shadow-none'
      )}
      {...props}
    >
      <h5>{props.children}</h5>
    </button>
  );
}

function MediumButton(props: ButtonProps) {
  return (
    <button
      className={clsx(
        'min-w-[240px] h-[60px] rounded-full text-body uppercase disabled:bg-gray-soft disabled:shadow-none disabled:border-none',
        props.secondary
          ? 'bg-white border border-gray-soft hover:border-body focus:border-dark'
          : 'bg-green hover:bg-green-hover hover:shadow-none focus:bg-green-focus focus:shadow-none'
      )}
      {...props}
    >
      <h5>{props.children}</h5>
    </button>
  );
}

function SmallButton(props: ButtonProps) {
  return (
    <button
      className="min-w-[280px] h-10 rounded-[10px] bg-white hover:text-dark focus:text-dark disabled:bg-gray-soft"
      {...props}
    >
      <Subtitle>{props.children}</Subtitle>
    </button>
  );
}

export function ExtraSmallButton({ secondary, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(
        'flex flex-1 justify-center items-center min-w-[120px] h-10 rounded-[10px] disabled:bg-gray-soft disabled:border-none',
        secondary
          ? 'bg-white border text-body border-gray-soft hover:border-body focus:border-dark focus:text-dark'
          : 'bg-green hover:bg-green-hover focus:bg-green-focus'
      )}
      {...props}
    >
      <Subtitle>{props.children}</Subtitle>
    </button>
  );
}

export function Button(props: ButtonProps) {
  switch (props.size) {
    case 'lg':
      return <LargeButton {...props} />;
    case 'md':
      return <MediumButton {...props} />;
    case 'sm':
      return <SmallButton {...props} />;
    case 'xs':
      return <ExtraSmallButton {...props} />;
  }
}
